window.ssSiteId = '40t3km';
const GRAPHQL_ENDPOINT = 'https://bl101.myshopify.com/api/2025-07/graphql.json';
const ACCESS_TOKEN = 'd97236582d67e5de2911bcda0671acb9';

document.addEventListener('DOMContentLoaded', function() {;
    window.ssPageLoadId = uuidv4();
})

export function objectToUrlParams(obj) {
    const params = [];

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            // Handle arrays by adding the same key multiple times with different values
            obj[key].forEach(value => {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            });
        } else {
            // Handle regular key-value pairs
            params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
        }
    }

    return params.join('&');
}

export function setCookie(cname, cvalue, exdays = 30) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export async function sendPreflight() {
    let userId = getCookie('ssUserId') || null;
    if (!userId) {
        userId = uuidv4();
        setCookie('ssUserId', userId);
    }
    const shopperId = getCookie('ssShopperId') || null;
    const cart = getCookie('ssCartProducts') || null;
    const lastViewed = getCookie('ssViewedProducts') || null;

    const preflightParams = objectToUrlParams({
        siteId: window.ssSiteId,
        userId,
        ...(shopperId ? {shopperId} : {}),
        ...(cart ? {cart} : {}),
        ...(lastViewed ? {lastViewed} : {})
    })

    const preflightUrl = `https://${window.ssSiteId}.a.searchspring.io/api/personalization/preflightCache?${preflightParams}`;

    const response = await fetch(preflightUrl, { method: 'GET', headers: { accept: 'application/json' } });

    return response;
}

// Function to set up infinite scrolling
export function setupInfiniteScroll(containerId, isLoadingMore = false, callback, options = {}) {
    // Clean up any previous observers and sentinels
    const existingSentinel = document.getElementById(options.sentinelId || 'scroll-sentinel');
    if (existingSentinel) {
        // If there's already an observer on it, disconnect it
        if (existingSentinel._observer) {
            existingSentinel._observer.disconnect();
        }
        existingSentinel.remove();
    }

    // Get the product grid
    const container = document.getElementById(containerId);
    if (!container) return; // Early return if container not found

    // Options for the Intersection Observer
    const observerOptions = {
        root: options.root || null, // Use the viewport as the root by default, or custom element
        rootMargin: options.rootMargin || '0px 0px 800px 0px', // Start loading more items when we're 800px from the bottom
        threshold: options.threshold || 0.01 // Trigger when at least 1% of the target is visible
    };

    // Create a sentinel element to observe for scrolling
    const sentinel = document.createElement('div');
    sentinel.id = options.sentinelId || 'scroll-sentinel';
    sentinel.style.height = '1px';
    sentinel.style.display = 'block';

    // Append the sentinel to the container itself
    container.appendChild(sentinel);

    // Set up the Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // If the sentinel is intersecting (visible) and we're not currently loading
            if (entry.isIntersecting && !isLoadingMore) {
                callback();
            }
        });
    }, observerOptions);

    // Store reference to observer on the element for cleanup
    sentinel._observer = observer;

    // Start observing the sentinel
    observer.observe(sentinel);
}

export function parseEncodedObject(object) {
  if (!object) {
    return null;
  }
    // Step 1: Remove the outer quotes if they exist
    let cleanedObject = typeof object === 'string' ? object.trim() : JSON.stringify(object).trim();
    if (cleanedObject.startsWith('"') && cleanedObject.endsWith('"')) {
      cleanedObject = cleanedObject.slice(1, -1);
    }

    // Step 2: Use DOMParser to decode HTML entities
    const parser = new DOMParser();
    const decodedText = parser.parseFromString(`<!doctype html><body>${cleanedObject}`, 'text/html').body.textContent;

    // Step 3: Parse the JSON
    try {
      const parsedData = JSON.parse(decodedText);

      // Step 4: Recursively decode nested values
      return deepDecodeObject(parsedData);
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }
}

// Helper function to recursively decode nested encoded strings
function deepDecodeObject(obj) {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map(item => deepDecodeObject(item));
  }

  // Handle objects
  if (typeof obj === 'object') {
    const decoded = {};
    for (const [key, value] of Object.entries(obj)) {
      decoded[key] = deepDecodeObject(value);
    }
    return decoded;
  }

  // Handle strings that might be encoded JSON
  if (typeof obj === 'string') {
    const trimmed = obj.trim();
    // Check if it looks like JSON (starts with [ or {)
    if ((trimmed.startsWith('[') && trimmed.endsWith(']')) ||
        (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
      try {
        const parsed = JSON.parse(trimmed);
        // Recursively decode the parsed result
        return deepDecodeObject(parsed);
      } catch (e) {
        // If parsing fails, return the original string
        return obj;
      }
    }
  }

  // Return primitives as-is
  return obj;
}

export function decodeEncodedString(value) {
  if (typeof value !== 'string') return value;
  let decoded = value;
  // Replace HTML entity &quot; with "
  decoded = decoded.replace(/&quot;/g, '"');
  // Remove ALL leading/trailing quotes (single or double, repeated)
  decoded = decoded.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '');
  // Remove any extra quotes that may have been double-encoded
  decoded = decoded.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '');
  // Replace escaped slashes with normal slashes
  decoded = decoded.replace(/\\\//g, '/');
  // Remove quotes again if still present after decoding
  decoded = decoded.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '');
  return decoded;
}

export async function getSwatchesFromGids(productGids) {
  if (!Array.isArray(productGids) || productGids.length === 0) {
      return {};
    }

    let decodedProductGids = productGids;

  const query = `
  query fetchMultipleProducts($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        handle
        url: onlineStoreUrl
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        swatchColors: metafield(namespace: "custom", key: "colors") {
          value
          type
        }
        swatchImages: metafield(namespace: "custom", key: "swatch-images") {
          value
          type
        }
        media(first: 2) {
          edges {
            node {
              ... on MediaImage {
                image {
                  url
                  small: transformedSrc(maxWidth: 200, maxHeight: 200, crop: CENTER)
                  medium: transformedSrc(maxWidth: 800, maxHeight: 800, crop: CENTER)
                  large: transformedSrc(maxWidth: 1000, maxHeight: 1000, crop: CENTER)
                }
              }
              ... on Video {
                sources {
                  url
                }
              }
            }
          }
        }
        variants(first: 20) {
          edges {
            node {
              id
              title
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              inventory_quantity: quantityAvailable
              sku
              available: availableForSale
            }
          }
        }
      }
    }
  }
`;

// If productGids are HTML-encoded (e.g., &quot;gid:\/\/shopify\/Product\/8222309122230&quot;), decode them to plain GIDs
if (Array.isArray(productGids)) {
  decodedProductGids = productGids.map(gid => decodeEncodedString(gid));
}

try {
  // Make the GraphQL request
  const response = await fetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: {
          ids: decodedProductGids,
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`GraphQL request failed: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    const swatchObjects = {};

    // Flatten each product before adding it to the swatchObjects
    data.data.nodes.forEach(product => {
      if (!product) return;
      // Flatten the product data to remove edges/nodes nesting
      const flattenedProduct = flattenGraphQLResponse(product);
      swatchObjects[product.id] = flattenedProduct;
    });

    // Check for errors in the GraphQL response
    if (data.errors) {
      throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
    }

    return swatchObjects;
} catch (error) {
  console.error('Error fetching products:', error);
  return null;
}
}

export function flattenGraphQLResponse(data) {
  if (!data) return null;

  // Handle case where data is already flattened or not in the expected format
  if (typeof data !== 'object') return data;

  // If data is an array, process each item
  if (Array.isArray(data)) {
    return data.map(item => flattenGraphQLResponse(item));
  }

  // Create a new object to store flattened data
  const flattened = {};

  // Process each key in the object
  for (const key in data) {
    // Check if the property has an 'edges' array (GraphQL connection pattern)
    if (data[key] && typeof data[key] === 'object' && Array.isArray(data[key].edges)) {
      // Extract the nodes from the edges and flatten them
      flattened[key] = data[key].edges.map(edge => {
        if (edge.node) {
          // Recursively flatten the node
          return flattenGraphQLResponse(edge.node);
        }
        return edge;
      });
    }
    // For nested objects that aren't edges/nodes pattern, DO NOT recursively flatten
    // Just copy them as is to preserve their structure
    else {
      flattened[key] = data[key];
    }
  }

  return flattened;
}

// Usage example for flattenGraphQLResponse
// Example GraphQL response with edges and nodes
/*
const exampleGraphQLResponse = {
  product: {
    id: "gid://shopify/Product/123456789",
    title: "Sample Product",
    // This nested object will be preserved as-is (not flattened)
    priceRange: {
      minVariantPrice: {
        amount: "19.99",
        currencyCode: "USD"
      },
      maxVariantPrice: {
        amount: "24.99",
        currencyCode: "USD"
      }
    },
    // This edges/nodes structure will be flattened
    variants: {
      edges: [
        {
          node: {
            id: "gid://shopify/ProductVariant/1",
            title: "Small",
            // This nested price object will be preserved as-is
            price: {
              amount: "19.99",
              currencyCode: "USD"
            }
          }
        },
        {
          node: {
            id: "gid://shopify/ProductVariant/2",
            title: "Medium",
            price: {
              amount: "21.99",
              currencyCode: "USD"
            }
          }
        }
      ]
    },
    // This edges/nodes structure will be flattened
    media: {
      edges: [
        {
          node: {
            image: { url: "https://example.com/image1.jpg" }
          }
        },
        {
          node: {
            image: { url: "https://example.com/image2.jpg" }
          }
        }
      ]
    }
  }
};

// After flattening:
// {
//   product: {
//     id: "gid://shopify/Product/123456789",
//     title: "Sample Product",
//     // Preserved as-is
//     priceRange: {
//       minVariantPrice: {
//         amount: "19.99",
//         currencyCode: "USD"
//       },
//       maxVariantPrice: {
//         amount: "24.99",
//         currencyCode: "USD"
//       }
//     },
//     // Flattened from edges/nodes
//     variants: [
//       {
//         id: "gid://shopify/ProductVariant/1",
//         title: "Small",
//         // Preserved as-is inside the node
//         price: {
//           amount: "19.99",
//           currencyCode: "USD"
//         }
//       },
//       {
//         id: "gid://shopify/ProductVariant/2",
//         title: "Medium",
//         price: {
//           amount: "21.99",
//           currencyCode: "USD"
//         }
//       }
//     ],
//     // Flattened from edges/nodes
//     media: [
//       { image: { url: "https://example.com/image1.jpg" } },
//       { image: { url: "https://example.com/image2.jpg" } }
//     ]
//   }
// }
*/



export async function addSwatchesToProducts(productResults) {

  const altProductGids = Array.from(
    new Set([
      ...productResults
        .filter(result => result.mfield_custom_alternate_versions || result.mfield_custom_alternate_versions_metaobject)
        .flatMap(result => {
          if (result.mfield_custom_alternate_versions_metaobject) {
            const parsedEncodedObject = parseEncodedObject(result.mfield_custom_alternate_versions_metaobject);
            return parsedEncodedObject?.value?.product || [];
          } else if (result.mfield_custom_alternate_versions) {
            return result.mfield_custom_alternate_versions;
          }
          return [];
        }),
      ...productResults
        .filter(result => result.uid)
        .map(result => `gid://shopify/Product/${result.uid}`)
    ])
  );

  // Decode any HTML-encoded GIDs in altProductGids
  for (let i = 0; i < altProductGids.length; i++) {
    const gid = altProductGids[i];
    altProductGids[i] = decodeEncodedString(gid);
  }

  const swatches = await getSwatchesFromGids(altProductGids);

  const productsWithSwatches = productResults.map(product => {
    if (!product) return null;
    if (product.variants) {
      const swatchProduct = swatches[`gid://shopify/Product/${product.uid}`];
      if (!swatchProduct) return null;
      product.variants = swatches[`gid://shopify/Product/${product.uid}`].variants;
    }
    if (product.mfield_custom_alternate_versions_metaobject) {
      const parsedEncodedObject = parseEncodedObject(product.mfield_custom_alternate_versions_metaobject);
      product.swatches = (parsedEncodedObject?.value?.product?.map(product => swatches[product]) || []).filter(Boolean);
    } else if (product.mfield_custom_alternate_versions?.length > 0) {
        // Ensure alternate_versions are decoded to plain GIDs
        if (Array.isArray(product.mfield_custom_alternate_versions)) {
          product.mfield_custom_alternate_versions = product.mfield_custom_alternate_versions.map(gid => decodeEncodedString(gid));
        }
        product.swatches = (product.mfield_custom_alternate_versions.map(swatch => swatches[swatch]) || []).filter(Boolean);
    }
    return product;
  })

  return productsWithSwatches;
}

export function isMobileDevice() {
  // Method 1: Check for touch capabilities
  const hasTouchScreen = (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );

  // Method 2: Check user agent string (less reliable but helpful as secondary check)
  const userAgentMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // Method 3: Check screen size
  const isSmallScreen = window.innerWidth <= 768;

  // Method 4: Media query for device capability
  const mediaQueryList = window.matchMedia("(hover: none) and (pointer: coarse)");
  const usesTouchInput = mediaQueryList.matches;

  // Return true if most checks suggest it's a mobile device
  return (hasTouchScreen && (userAgentMobile || isSmallScreen || usesTouchInput));
}

export function populateSortByOptions(sortByOptions) {
    const sortBySelect = document.getElementById('SortBy');
    if (!sortBySelect) return;

    // Clear existing options from the sort by select element
    sortBySelect.innerHTML = '';

    const urlParams = new URLSearchParams(window.location.search);
    let currentSort = '';

    // Check all URL parameters for any that start with "sort."
    for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('sort.')) {
            currentSort = `${key}=${value}`;
            break;
        }
    }

    // Create default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Default';
    sortBySelect.appendChild(defaultOption);

    // Create and append option elements for each sort option
    const fragment = document.createDocumentFragment();
    sortByOptions.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = `sort.${option.field}=${option.direction}`;
        optionElement.textContent = option.label;
        if (currentSort === optionElement.value) {
            optionElement.selected = true;
        }
        fragment.appendChild(optionElement);
    });

    sortBySelect.appendChild(fragment);
}

export function updateAddBothToCartButton(addBothButton, knownVariant) {
  const addBothButtonText = addBothButton.querySelector('span');
  const select = document.querySelector('.bundle-card .variant-select');
  const selectedVariant = knownVariant || select.value;

  if (!selectedVariant) {
    setButtonToSelectSize(addBothButton, addBothButtonText);
    return;
  }

  const mainAddToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
  const isMainButtonDisabled = mainAddToCartButton?.disabled ?? false;

  setButtonState(addBothButton, addBothButtonText, isMainButtonDisabled);
}

function setButtonToSelectSize(button, buttonText) {
  button.disabled = true;
  buttonText.textContent = 'Select a Size';
}

function setButtonState(button, buttonText, isMainButtonDisabled) {
  button.disabled = false;
  button.dataset.singleItem = isMainButtonDisabled;
  buttonText.textContent = isMainButtonDisabled ? 'Add to Cart' : 'Add Both to Cart';
}

export async function getInventoryFromGids(variantIds) {
    if (!Array.isArray(variantIds) || variantIds.length === 0) {
        return {};
    }

    const query = `
    query fetchVariantInventory($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          title
          inventory_quantity: quantityAvailable
          available: availableForSale
        }
      }
    }
    `;

    try {
        const response = await fetch(GRAPHQL_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
            },
            body: JSON.stringify({
                query,
                variables: {
                    ids: variantIds.map(id => `gid://shopify/ProductVariant/${id}`),
                },
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`GraphQL request failed: ${response.status} ${errorText}`);
        }

        const data = await response.json();
        const inventoryObjects = {};

        // Process each variant and extract inventory information
        data.data.nodes.forEach(variant => {
            if (!variant) return;
            inventoryObjects[variant.id.split('/').pop()] = {
                title: variant.title,
                quantity: variant.inventory_quantity,
                available: variant.available
            };
        });

        if (data.errors) {
            throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
        }

        return inventoryObjects;
    } catch (error) {
        console.error('Error fetching variant inventory:', error);
        return null;
    }
}

export async function getProductInventory(productIds) {
  if (!Array.isArray(productIds) || productIds.length === 0) {
      return {};
  }

  const query = `
  query fetchProductInventory($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        publishedAt
        totalInventory
      }
    }
  }
  `;

  try {
      const response = await fetch(GRAPHQL_ENDPOINT, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
          },
          body: JSON.stringify({
              query,
              variables: {
                  ids: productIds.map(id => `gid://shopify/Product/${id}`),
              },
          }),
      });

      if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`GraphQL request failed: ${response.status} ${errorText}`);
      }

      const data = await response.json();
      const inventoryObjects = {};

      if (!data?.data?.nodes) {
        return null;
      }

      // Process each variant and extract inventory information
      data.data.nodes.forEach(product => {
          if (!product) return;
          inventoryObjects[product.id.split('/').pop()] = {
              title: product.title,
              publishedAt: product.publishedAt,
              totalInventory: product.totalInventory,
          };
      });

      if (data.errors) {
          throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
      }

      return inventoryObjects;
  } catch (error) {
      console.error('Error fetching variant inventory:', error);
      return null;
  }
}

document.addEventListener('rebuy:smartcart.ready', () => {

  const widgetContainers = document.querySelectorAll('[data-rebuy-component="cross-sell-widget"]');

  widgetContainers.forEach(container => {
    // Wait for the widget to be ready
    setTimeout(() => {
      const crossSellSizeButtons = container.querySelectorAll('.rebuy-button');

      crossSellSizeButtons.forEach(button => {

        // Only apply to size buttons
        const buttonText = button.innerText.toLowerCase();
        if (!buttonText.includes('size')) return;

        button.addEventListener('click', async () => {
          const options = container.querySelectorAll('.rebuy-product-options option');
          const optionValues = Array.from(options).map(option => option.value);

          const inventory = await getInventoryFromGids(optionValues);

          optionValues.forEach(optionValue => {
            const variantInventory = inventory[optionValue];
            if (variantInventory.quantity <= 0) {
              const matchingOption = document.querySelector(`option[value="${optionValue}"]`)
              if (matchingOption) {
                const select = matchingOption.closest('select');
                matchingOption.remove();
                if (select) {
                  const remainingOptions = Array.from(select.options);
                  if (remainingOptions.length > 0) {
                    select.value = remainingOptions[0].value;
                    remainingOptions[0].selected = true;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }
            }
          })
        });
      });
    }, 1000);


  });
});

// This function is used to filter out or in products from the early drop collection
// It checks to see if there is an edc_collection cookie, which is set in global.js if the shop metafield object is present in the DOM (which gets rendered in theme.liquid)
// If the edc_collection cookie is present, it checks to see if the edc_code cookie is present and matches the edc_url_param_code in the shop metafield object
// If the edc_code cookie is present and matches the edc_url_param_code, it returns all results
// If the edc_code cookie is present but does not match the edc_url_param_code, it filters out products from the early drop collection
// If the edc_collection cookie is present but the edc_code cookie is not present, it filters out products from the early drop collection
// If the edc_collection cookie is not present, it returns all results
export async function filterProductsByEarlyDrop(results) {
  // Look for the 'edc_collection' cookie and filter results if present
  const edcCollectionCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('edc_collection='));

  if (edcCollectionCookie) {
      let filterOut = true;
      const edcCollection = decodeURIComponent(edcCollectionCookie.split('=')[1]);
      if (!edcCollection) {
        return results;
      }
      const edcCodeCookie = document.cookie
          .split('; ')
          .find(row => row.startsWith('edc='));

      const edcCode = edcCodeCookie ? decodeURIComponent(edcCodeCookie.split('=')[1]) : null;

      if (edcCollection && edcCode) {
        const metafieldEl = document.getElementById('shop-metafields-data');
        if (metafieldEl) {
          const earlyDropMetafield = JSON.parse(metafieldEl.textContent);
          if (earlyDropMetafield.edc_url_param_code === edcCode) {
            filterOut = false;
          }
        } else {
          filterOut = false;
        }
      }
      // if the cookie is present and correct, return all results
      if (!filterOut) return results;

      // hide search results count bc it will be inaccurate
      const searchResultsCount = document.getElementById('ss-search-results-count');
      if (searchResultsCount) {
          searchResultsCount.classList.add('hidden');
      }

      // otherwise, filter out products from the early drop collection
      return results.filter(product => {
        const handles = product.collection_handle;
        if (!Array.isArray(handles) || handles.length === 0) return true; // include if missing
        return !handles.includes(edcCollection);
      });
  } else {
      return results;
  }
}

export async function getProductsFromCollection(collectionHandle, params) {

  const SITE_ID = window.ssSiteId;
  const { limit = 24, page = 1, ...restParams } = params;

  const urlParams = new URLSearchParams(window.location.search);
  const filters = urlParams.get('filters') || '';

  if (filters) {
    const filtersArray = filters.split(',');
    filtersArray.forEach(filter => {
        const [key, value] = filter.split(':');

        // Check if this is a range filter (ends with .low or .high)
        const isRangeFilter = key.endsWith('.low') || key.endsWith('.high');

        if (isRangeFilter) {
            // For range filters, we just add them directly to the params
            if (restParams[key] !== undefined) {
                if (Array.isArray(restParams[key])) {
                    restParams[key].push(value);
                } else {
                    restParams[key] = [restParams[key], value];
                }
            } else {
                restParams[key] = value;
            }
        }
    });
  }


  const searchParams = {
    siteId: SITE_ID,
    resultsFormat: 'json',
    resultsPerPage: limit,
    page,
    userId: getCookie('ssUserId') || '',
    sessionId: getCookie('ssSessionIdNamespace') || '',
    pageLoadId: window.ssPageLoadId,
    domain: window.location.href,
    redirectResponse: 'minimal',
    'bgfilter.collection_handle': collectionHandle,
    'bgfilter.limit': limit,
    ...restParams
  }

  const queryString = objectToUrlParams(searchParams);

  // Build the SearchSpring API URL with the query parameter
  const apiUrl = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?bgfilter.status=active&${queryString}`;

  try {
      // Send preflight request first
      await sendPreflight();

      // Make the GET request to the SearchSpring API
      const response = await fetch(apiUrl);

      // Handle redirects
      if (response.redirected) {
          window.location.href = response.url;
          return;
      }

      if (!response.ok) {
          throw new Error('Network response was not ok');
      }

      const data = await response.json();

      const filteredResults = await filterProductsByEarlyDrop(data.results);

      // Process products with swatches
      const productsWithSwatches = await addSwatchesToProducts(filteredResults);

      // Add inline merchandising to results
      if (data.merchandising?.content?.inline?.length > 0) {
          data.merchandising.content.inline.forEach(item => {
              const content = item.value;
              const {index} = item.config?.position || 0;
              productsWithSwatches.splice(index, 0, {
                  content,
                  isMerchandising: true,
              });
          });
      }

      // Return the products with pagination info
      return {
        products: productsWithSwatches,
        merchandising: data.merchandising,
        pagination: data.pagination
      };



  } catch (error) {
      // Don't log errors for intentional redirects
      if (!error.message.startsWith('Redirecting to')) {
          console.error('Error fetching search results:', error);
      }
  }
}

// Helper function to process merchandising content
export function processSearchMerchandisingContent(merchandisingContent) {
  Object.keys(merchandisingContent).forEach(key => {
      const targetElement = document.getElementById(`ss-merchandising-${key}`);

      if (!targetElement || !Array.isArray(merchandisingContent[key])) return;

      // Clear any existing content
      targetElement.innerHTML = '';

      // Process each HTML element for this key
      merchandisingContent[key].forEach(htmlContent => {
          // Check if content is wrapped in script tags and remove them
          const scriptRegex = /^<script[^>]*>([\s\S]*)<\/script>$/i;
          const match = scriptRegex.exec(htmlContent);
          const cleanContent = match && match[1] ? match[1].trim() : htmlContent;

          // Append the cleaned content
          targetElement.innerHTML += cleanContent;
      });
  });
}

export function normalizePrice(priceValue) {
  if (typeof priceValue === 'object' && priceValue !== null) {
    return { amount: priceValue.amount };
  }
  return { amount: priceValue };
}

export function normalizeCompareAtPrice(variant) {
  if (variant.compareAtPrice) {
    return normalizePrice(variant.compareAtPrice);
  }
  if (variant.compare_at_price !== undefined) {
    return { amount: variant.compare_at_price };
  }
  return normalizePrice(variant.price);
}

if (typeof window !== 'undefined') {
  window.ssUtils = window.ssUtils || {};
  if (!window.ssUtils._initialized_v2) {
  Object.assign(window.ssUtils, {
    objectToUrlParams,
    getCookie,
    sendPreflight,
    setupInfiniteScroll,
    parseEncodedObject,
    getSwatchesFromGids,
    flattenGraphQLResponse,
    addSwatchesToProducts,
    isMobileDevice,
    populateSortByOptions,
    updateAddBothToCartButton,
    getInventoryFromGids,
    getProductInventory,
    filterProductsByEarlyDrop,
    processSearchMerchandisingContent,
    getProductsFromCollection,
    normalizePrice,
    normalizeCompareAtPrice,
    _initialized_v2: true
  });
  }
  Object.freeze(window.ssUtils);
}